import React from "react"
import { Link } from "gatsby"
import { css, jsx } from "@emotion/core"
import Button from "../button"
import Events from "../events/event"

const UpcomingEvents = () => (
  <div css={{ marginTop: "25px", padding: "5px", marginBottom: "3rem" }}>
    <h3 css={{ marginBottom: "0.667rem", borderBottom: "1px dotted #abadb3" }}>
      Upcoming Events
    </h3>
    <div
      css={{
        fontSize: "0.85rem",
        marginBottom: "0.667rem",
      }}
    >
      <Events />
    </div>
    <Button to="/about/calendar" text="View Calendar" />
  </div>
)

export default UpcomingEvents
